// Back end connection and configaration

export const config = {
    api: "https://doctor-appointment-backend-pxpc.onrender.com", //"http://localhost:3000"
    storage_key: "appoint_key"
}